module.exports = __webpack_public_path__ + "img/tumecanico.961fe397.png";